// import React, { useEffect, useState } from "react";
// import { use } from "react";
// import { USER_URL } from "../../constant/api";
// import { toast } from "react-toastify";

// const AdminCreateUnit = () => {
//   // Unit states
//   const [units, setUnits] = useState([]);
//   const [unitName, setUnitName] = useState("");
//   const [unitShortCode, setUnitShortCode] = useState("");
//   const [unitError, setUnitError] = useState("");

//   // Currency states
//   const [currencies, setCurrencies] = useState([]);
//   const [currencyName, setCurrencyName] = useState("");
//   const [currencySymbol, setCurrencySymbol] = useState("");
//   const [currencyError, setCurrencyError] = useState("");

//   const handleAddUnit = async(e) => {
//     e.preventDefault();
//     const trimmedName = unitName.trim();
//     const trimmedShortCode = unitShortCode.trim();

//     if (!trimmedName) {
//       setUnitError("Unit name cannot be empty.");
//       return;
//     }

//     if (!trimmedShortCode) {
//       setUnitError("Unit short code cannot be empty.");
//       return;
//     }

//     const isDuplicate = units.some(
//       (unit) => unit.toLowerCase() === trimmedName.toLowerCase(),
//     );
//     if (isDuplicate) {
//       setUnitError("Unit already exists.");
//       return;
//     }

//    const newUnit = {
//       name: trimmedName,
//       shortCode: trimmedShortCode,
//     };

//     try {
//       await USER_URL.post("https://api.example.com/units", newUnit);
//       console.log("Unit added:", newUnit);
//       toast.success("Unit added successfully.");
//     } catch (error) {
//       console.error("Error adding unit:", error);
//       toast.error("Failed to add unit.");

//     }

//     setUnits([...units, newUnit]);
//     setUnitName("");
//     setUnitShortCode("");
//     setUnitError("");
//   };

//   const handleAddCurrency = async(e) => {
//     e.preventDefault();
//     const trimmedName = currencyName.trim();
//     const trimmedSymbol = currencySymbol.trim();

//     if (!trimmedName) {
//       setCurrencyError("Currency name cannot be empty.");
//       return;
//     }

//     if (!trimmedSymbol) {
//       setCurrencyError("Currency symbol cannot be empty.");
//       return;
//     }

//     const isDuplicate = currencies.some(
//       (currency) => currency.toLowerCase() === trimmedName.toLowerCase(),
//     );
//     if (isDuplicate) {
//       setCurrencyError("Currency already exists.");
//       return;
//     }
//     const newCurrency = {
//       name: trimmedName,
//       symbol: currencySymbol,
//     };
//     try {
//       await USER_URL.post("https://api.example.com/currencies", newCurrency);
//       console.log("Currency added:", newCurrency);
//       toast.success("Currency added successfully.");
//     } catch (error) {
//       console.error("Error adding currency:", error);
//       toast.error("Failed to add currency.");
//     }

//     setCurrencies([...currencies, { name: trimmedName, symbol: currencySymbol }]);
//     setCurrencyName("");
//     setCurrencySymbol("");
//     setCurrencyError("");
//   };

//   const fetchUnits = async () => {
//     try {
//       const response = await USER_URL.get("https://api.example.com/units");
//       setUnits(response.data);
//       console.log("Units fetched:", response.data);
//     } catch (error) {
//       console.error("Error fetching units:", error);
//       // toast.error("Failed to fetch units.");
//     }
//   };

//   const fetchCurrencies = async () => {
//     try {
//       const response = await USER_URL.get("https://api.example.com/currencies");
//       setCurrencies(response.data);
//       console.log("Currencies fetched:", response.data);
//     } catch (error) {
//       console.error("Error fetching currencies:", error);
//       // toast.error("Failed to fetch currencies.");
//     }
//   };

//   useEffect(() => {
//     fetchUnits();
//     fetchCurrencies();
//   }, []);

//   return (
//     <div className="flex w-full flex-col md:flex-row gap-9 p-6">
//       {/* Unit Form */}
//       <div className="flex w-full md:w-1/2 flex-col gap-4">
//         <h2 className="mb-4 text-2xl font-bold text-brand-primary">Create Unit</h2>
//         <form onSubmit={handleAddUnit} className="flex flex-col gap-4">
//           <input
//             type="text"
//             placeholder="Enter unit name (e.g., Kilogram)"
//             value={unitName}
//             onChange={(e) => setUnitName(e.target.value)}
//             className="rounded border border-gray-300 p-2"
//           />
//           {unitError && <p className="text-red-500">{unitError}</p>}
//           <button
//             type="submit"
//             className="hover:bg-brand-primary-dark rounded bg-brand-primary py-2 text-white transition duration-200"
//           >
//             Add Unit
//           </button>
//         </form>
//         <div className="mt-6">
//           <h3 className="mb-2 text-xl font-semibold">Existing Units</h3>
//           {units.length === 0 ? (
//             <p className="text-gray-500">No units added yet.</p>
//           ) : (
//             <ul className="list-inside list-disc space-y-1">
//               {units.map((unit, index) => (
//                 <li key={index}>{unit}</li>
//               ))}
//             </ul>
//           )}
//         </div>
//       </div>

//       {/* Currency Form */}
//       <div className="flex w-full md:w-1/2 flex-col gap-4">
//         <h2 className="mb-4 text-2xl font-bold text-brand-primary">Create Currency</h2>
//         <form onSubmit={handleAddCurrency} className="flex flex-col gap-4">
//           <input
//             type="text"
//             placeholder="Enter currency name (e.g., USD)"
//             value={currencyName}
//             onChange={(e) => setCurrencyName(e.target.value)}
//             className="rounded border border-gray-300 p-2"
//           />
//           {currencyError && <p className="text-red-500">{currencyError}</p>}
//           <button
//             type="submit"
//             className="hover:bg-brand-primary-dark rounded bg-brand-primary py-2 text-white transition duration-200"
//           >
//             Add Currency
//           </button>
//         </form>
//         <div className="mt-6">
//           <h3 className="mb-2 text-xl font-semibold">Existing Currencies</h3>
//           {currencies.length === 0 ? (
//             <p className="text-gray-500">No currencies added yet.</p>
//           ) : (
//             <ul className="list-inside list-disc space-y-1">
//               {currencies.map((currency, index) => (
//                 <li key={index}>{currency}</li>
//               ))}
//             </ul>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminCreateUnit;

import React, { useEffect, useState } from "react";
import { USER_URL } from "../../constant/api";
import { toast } from "react-toastify";
import { LuDelete } from "react-icons/lu";
import { MdDelete } from "react-icons/md";

const AdminCreateUnit = () => {
  // Unit states
  const [units, setUnits] = useState([]);
  const [unitName, setUnitName] = useState("");
  const [unitShortCode, setUnitShortCode] = useState("");
  const [unitError, setUnitError] = useState("");

  // Currency states
  const [currencies, setCurrencies] = useState([]);
  const [currencyName, setCurrencyName] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [currencyShortCode, setCurrencyShortCode] = useState("");
  const [currencyError, setCurrencyError] = useState("");

  const handleAddUnit = async (e) => {
    e.preventDefault();
    const trimmedName = unitName.trim();
    const trimmedShortCode = unitShortCode.trim();

    if (!trimmedName) {
      setUnitError("Unit name cannot be empty.");
      return;
    }

    if (!trimmedShortCode) {
      setUnitError("Unit short code cannot be empty.");
      return;
    }

    const isDuplicate = units.some(
      (unit) => unit.name.toLowerCase() === trimmedName.toLowerCase(),
    );
    if (isDuplicate) {
      setUnitError("Unit already exists.");
      return;
    }

    const newUnit = {
      name: trimmedName,

      short_code: trimmedShortCode,
    };

    try {
      await USER_URL.post("/products/admin/unit/", newUnit);
      toast.success("Unit added successfully.");
      setUnits([...units, newUnit]);
      setUnitName("");
      setUnitShortCode("");
      setUnitError("");
    } catch (error) {
      console.error("Error adding unit:", error);
      toast.error("Failed to add unit.");
    }
  };

  const handleAddCurrency = async (e) => {
    e.preventDefault();
    const trimmedName = currencyName.trim();
    const trimmedSymbol = currencySymbol.trim();

    if (!trimmedName) {
      setCurrencyError("Currency name cannot be empty.");
      return;
    }

    if (!trimmedSymbol) {
      setCurrencyError("Currency symbol cannot be empty.");
      return;
    }
    if (!currencyShortCode) {
      setCurrencyError("Currency short code cannot be empty.");
      return;
    }

    const isDuplicate = currencies.some(
      (currency) => currency.name.toLowerCase() === trimmedName.toLowerCase(),
    );
    if (isDuplicate) {
      setCurrencyError("Currency already exists.");
      return;
    }

    const newCurrency = {
      name: trimmedName,
      symbol: trimmedSymbol,
      // short_code: currencyShortCode,
    };

    try {
      await USER_URL.post("/products/admin/currency/", newCurrency);
      toast.success("Currency added successfully.");
      setCurrencies([...currencies, newCurrency]);
      setCurrencyName("");
      setCurrencySymbol("");
      setCurrencyShortCode("");
      setCurrencyError("");
    } catch (error) {
      console.error("Error adding currency:", error);
      toast.error("Failed to add currency.");
    }
  };

  const fetchUnits = async () => {
    try {
      const response = await USER_URL.get("/products/admin/unit/");
      console.log("Units fetched:", response.data.data);

      setUnits(response.data.data);
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await USER_URL.get("/products/admin/currency/");
      console.log("Currencies fetched:", response.data.data);
      setCurrencies(response.data.data);
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  };

  useEffect(() => {
    fetchUnits();
    fetchCurrencies();
  }, []);

  const handleDeleteUnit = async (unitId) => {
    try {
      const data = {
        id: unitId,
      };
      await USER_URL.delete(`/products/admin/unit/`, {
        data,
      });
      setUnits(units.filter((unit) => unit.id !== unitId));
      toast.success("Unit deleted successfully.");
    } catch (error) {
      console.error("Error deleting unit:", error);
      toast.error("Failed to delete unit.");
    }
  }

  const handleDeleteCurrency = async (currencyId) => {
    try {
      const data = {
        id: currencyId,
      };
      await USER_URL.delete(`/products/admin/currency/`, {
        data,
      });
      setCurrencies(currencies.filter((currency) => currency.id !== currencyId));
      toast.success("Currency deleted successfully.");
    } catch (error) {
      console.error("Error deleting currency:", error);
      toast.error("Failed to delete currency.");
    }
  }

  return (
    <div className="flex w-full flex-col gap-9 p-6 md:flex-row">
      {/* Unit Form */}
      <div className="flex w-full flex-col gap-4 md:w-1/2">
        <h2 className="mb-4 text-2xl font-bold text-brand-primary">
          Create Unit
        </h2>
        <form onSubmit={handleAddUnit} className="flex flex-col gap-4">
          <input
            type="text"
            placeholder="Enter unit name (e.g., Kilogram)"
            value={unitName}
            onChange={(e) => setUnitName(e.target.value)}
            className="rounded border border-gray-300 p-2"
          />
          <input
            type="text"
            placeholder="Enter unit short code (e.g., kg)"
            value={unitShortCode}
            onChange={(e) => setUnitShortCode(e.target.value)}
            className="rounded border border-gray-300 p-2"
          />
          {unitError && <p className="text-red-500">{unitError}</p>}
          <button
            type="submit"
            className="hover:bg-brand-primary-dark rounded bg-brand-primary py-2 text-white transition duration-200"
          >
            Add Unit
          </button>
        </form>
        <div className="mt-6">
          <h3 className="mb-2 text-xl font-semibold">Existing Units</h3>
          {units.length === 0 ? (
            <p className="text-gray-500">No units added yet.</p>
          ) : (
            <ul className="list-inside  space-y-2">
              {units?.map((unit, index) => (
                <li key={unit.id} className="bg-green-100 p-2 flex justify-between items-center rounded">
                  {unit.name} ({unit.short_code}) <MdDelete onClick={() => handleDeleteUnit(unit.id)} className="cursor-pointer hover:text-red-500" />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Currency Form */}
      <div className="flex w-full flex-col gap-4 md:w-1/2">
        <h2 className="mb-4 text-2xl font-bold text-brand-primary">
          Create Currency
        </h2>
        
        <form onSubmit={handleAddCurrency} className="flex flex-col gap-4">
          <input
            type="text"
            placeholder="Enter currency name (e.g., United States Dollar)"
            value={currencyName}
            onChange={(e) => setCurrencyName(e.target.value)}
            className="rounded border border-gray-300 p-2"
          />
          <input
            type="text"
            placeholder="Enter currency symbol (e.g., $)"
            value={currencySymbol}
            onChange={(e) => setCurrencySymbol(e.target.value)}
            className="rounded border border-gray-300 p-2"
          />

          {currencyError && <p className="text-red-500">{currencyError}</p>}
          <button
            type="submit"
            className="hover:bg-brand-primary-dark rounded bg-brand-primary py-2 text-white transition duration-200"
          >
            Add Currency
          </button>
        </form>
        <div className="mt-6">
          <h3 className="mb-2 text-xl font-semibold">Existing Currencies</h3>
          {currencies.length === 0 ? (
            <p className="text-gray-500">No currencies added yet.</p>
          ) : (
            <ul className="list-inside  space-y-2">
              {currencies?.map((currency, index) => (
                <li key={currency.id} className="bg-green-100 p-2 flex justify-between items-center rounded">
                  {currency.name} ({currency.symbol}) <MdDelete onClick={() => handleDeleteCurrency(currency.id)} className="cursor-pointer hover:text-red-500" />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminCreateUnit;
